module.exports = __webpack_public_path__ + "media/tribute_no2_origin.2b711386.mp4";